import $ from 'jquery';
import 'lightgallery';
import 'lg-video';

class LightGallery {
	constructor(options) {
		if (options.youtube) {
			this.createVideoGallery(options);
		} else {
			this.createGallery(options);
		}
	}

	createGallery(options) {		
		$(options.parent).lightGallery({
			selector: options.selector
		});
	}

	createVideoGallery(options) {
		$(options.parent).lightGallery({
			selector: options.selector,
		    youtubePlayerParams: {
	            modestbranding: 1,
	            showinfo: 0,
	            rel: 0,
	            controls: 1,
	            autoplay: 1
		    }
		});
	}
}

export default {
	init() {
		new LightGallery();
	},
	new(options) {
		this.gallery = new LightGallery(options);
	}
}


// WEBPACK FOOTER //
// ./src/js/modules/lightGallery.js